import React from 'react';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import { HasRelationship } from 'Views/FreemiumEntry/HasRelationship';
import { Redirect } from 'react-router-dom';

const FreemiumEntry = () => {
  const { homeResource } = useHomeContext();

  const relationship = homeResource.withRelationship(fr.relationships.eqfQuiz.name,
    (rel) => rel,
    () => null);

  if (relationship) {
    return <HasRelationship relationship={relationship} />;
  }
  return <Redirect to={'/'} />;
};

export default FreemiumEntry;
